import styled from 'styled-components';
import { colors } from '~/styles/colors';

export const CompressoresContainer = styled.main`
  width: 100%;
  max-width: none;
  min-height: 100vh;
  padding: 24px 16px 40px;
  background: ${colors.white};
  box-sizing: border-box;

  .cs__guest-logo {
    display: block;
    width: 120px;
    height: auto;
    margin: 0 auto 18px;
    object-fit: contain;
  }

  #root {
    width: 90%;
    margin: 0 auto;
  }

  .cs__page {
    padding: 16px;
    margin-top: 12px;
    background: #f7f9fc;
  }

  .cs__card {
    background: ${colors.white};
    border-radius: 12px;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.04);
    padding: 14px;
  }

  .cs__card-title {
    color: ${colors.primary};
    font-size: 20px;
    font-weight: 900;
    margin-bottom: 10px;
  }

  .cs__suffix {
    color: ${colors.black};
    font-size: 18px;
    min-width: 50px;
    text-align: right;
  }

  .cs__tabs {
    display: flex;
    gap: 8px;
  }

  .cs__tab {
    border-radius: 10px;
    padding: 8px 10px;
    font-size: 18px;
    font-weight: 900;
    color: ${colors.gray100};
    background: ${colors.gray10};
  }

  .cs__tab.is-active {
    color: ${colors.black};
    background: rgba(0, 0, 0, 0.03);
  }

  .cs__block {
    border-radius: 10px;
    padding: 10px;
  }

  .cs__block-title {
    color: ${colors.primary};
    font-size: 18px;
    font-weight: 900;
    margin-bottom: 6px;
  }

  .cs__kv-k {
    color: ${colors.black};
    font-size: 16px;
  }

  .cs__kv-v {
    color: ${colors.black};
    font-size: 16px;
    font-weight: 900;
  }

  .cs__actions {
    gap: 10px;
    padding: 5px;
  }

  .cs__image-box {
    border: 2px solid rgba(0, 0, 0, 0.08);
    border-radius: 10px;
    padding: 12px;
    height: 210px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .cs__graph-box {
    padding: 12px;
    height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .cs__image {
    max-width: 100%;
    max-height: 180px;
    object-fit: contain;
  }

  .cs__label {
    color: black;
    font-size: 18px;
    font-weight: 900;
  }

  .cs__status {
    background: ${colors.gray10};
    border-radius: 10px;
    padding: 10px;
    color: ${colors.gray200};
    font-size: 13px;
    text-align: center;
  }
`;
